import type { ResponsibilityCard } from '@/types/prioritization/responsibility';

/**
 * The acts an ask can take in one click where it is drawn: one RPC, nothing typed,
 * safe to repeat (Notify and act §3.4). complete_note: a note's reminder (1058).
 */
export const ONE_CLICK = new Set(['complete_note']);

/** The card's one-click act, when it has one. */
export function quickActionOf(card: ResponsibilityCard | null | undefined) {
  const a = card?.valid_actions?.[0];
  return a && a.rpc && ONE_CLICK.has(a.rpc) ? a : null;
}

